/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * Where a post-auth-action flow (sign up, forgot/reset password, verify email) sends the user
 * once it's done.
 *
 * `/sign-in` renders a 404 (see SignInPage.js) once REACT_APP_IS_USER_LOGIN_ALLOWED is false, so
 * navigating there unconditionally strands the user. Registration and login are always
 * enabled/disabled together on a given deployment — there is no configuration where one is true
 * and the other false — so "both disabled" is the one case needing a different destination: the
 * app's home page at "/", which Home.js already resolves to the Admin Page Builder's configured
 * Custom or Default homepage via usePublicIndex()'s app_branding.homepage_type.
 */

import envConfig from "../config/envConfig";

export function getPostAuthDestination() {
  const authDisabled = !envConfig.isUserRegistrationAllowed && !envConfig.isUserLoginAllowed;
  return authDisabled ? "/" : "/sign-in";
}
